import { ICategory } from './categories';
import { IGroup } from './groups';

export interface IOptionGroup {
  groupTitle?: string;
  options: IOption[];
  isOpen?: boolean;
}

export interface IOption {
  name: string;
  selected: boolean;
}

export const optionsDefaultClassName = 'col-6 col-md-4 col-lg-5';

export enum IOffering {
  AfricanCuisine = 'africanCuisine',
  Alcohol = 'alcohol',
  AmericanCuisine = 'americanCuisine',
  ArabianCuisine = 'arabianCuisine',
  ArgentineanCuisine = 'argentineanCuisine',
  AsianCuisine = 'asianCuisine',
  AustrianCuisine = 'austrianCuisine',
  Bakery = 'bakery',
  Barbecue = 'barbecue',
  Beer = 'beer',
  BeerGarden = 'beerGarden',
  BelgianCuisine = 'belgianCuisine',
  Bistro = 'bistro',
  Bnb = 'bnb',
  Brasserie = 'brasserie',
  BrazilianCuisine = 'brazilianCuisine',
  Breakfast = 'breakfast',
  Brewery = 'brewery',
  BritishCuisine = 'britishCuisine',
  Brunch = 'brunch',
  Burger = 'burger',
  BusinessLunch = 'businessLunch',
  Cafe = 'cafe',
  CakesAndTarts = 'cakesAndTarts',
  CaucasianCuisine = 'caucasianCuisine',
  Cheese = 'cheese',
  ChineseCuisine = 'chineseCuisine',
  ChocolateAndJam = 'chocolateAndJam',
  Club = 'club',
  Cocktails = 'cocktails',
  Coffee = 'coffee',
  CoffeeToGo = 'coffeeToGo',
  Coffeehouse = 'coffeehouse',
  CorsicanCuisine = 'corsicanCuisine',
  CraftBeer = 'craftBeer',
  CroatianCuisine = 'croatianCuisine',
  Curry = 'curry',
  CzechCuisine = 'czechCuisine',
  Delicatessen = 'delicatessen',
  Dessert = 'dessert',
  Dinner = 'dinner',
  Disco = 'disco',
  Donuts = 'donuts',
  DutchCuisine = 'dutchCuisine',
  FastFood = 'fastFood',
  Fish = 'fish',
  FrenchCuisine = 'frenchCuisine',
  FreshBread = 'freshBread',
  FreshJuice = 'freshJuice',
  FruitsAndVegetables = 'fruitsAndVegetables',
  FruitsBar = 'fruitsBar',
  FusionCuisine = 'fusionCuisine',
  GeorgianCuisine = 'georgianCuisine',
  GermanCuisine = 'germanCuisine',
  GlutenFree = 'glutenFree',
  GourmetFood = 'gourmetFood',
  GreekCuisine = 'greekCuisine',
  Grill = 'grill',
  Halal = 'halal',
  HealthyCuisine = 'healthyCuisine',
  Heuriger = 'heuriger',
  HomeMadeCuisine = 'homeMadeCuisine',
  HungarianCuisine = 'hungarianCuisine',
  IceCream = 'iceCream',
  IndianCuisine = 'indianCuisine',
  InternationalCuisine = 'internationalCuisine',
  IsraeliCuisine = 'israeliCuisine',
  ItalianCuisine = 'italianCuisine',
  JapaneseCuisine = 'japaneseCuisine',
  Journals = 'journals',
  Karaoke = 'karaoke',
  Kebab = 'kebab',
  KoreanCuisine = 'koreanCuisine',
  Kosher = 'kosher',
  LactoseFree = 'lactoseFree',
  LebaneseCuisine = 'lebaneseCuisine',
  LiveMusic = 'liveMusic',
  LocalProducts = 'localProducts',
  Lounge = 'lounge',
  Lunch = 'lunch',
  MediterraneanCuisine = 'mediterraneanCuisine',
  MexicanCuisine = 'mexicanCuisine',
  MiddleAsianCuisine = 'middleAsianCuisine',
  MongolianCuisine = 'mongolianCuisine',
  MoroccanCuisine = 'moroccanCuisine',
  Newspaper = 'newspaper',
  OrientalCuisine = 'orientalCuisine',
  Paella = 'paella',
  Pancakes = 'pancakes',
  Pasta = 'pasta',
  PastaBar = 'pastaBar',
  Pastry = 'pastry',
  PersianCuisine = 'persianCuisine',
  Pierogi = 'pierogi',
  Pizza = 'pizza',
  PolishCuisine = 'polishCuisine',
  PortugueseCuisine = 'portugueseCuisine',
  Pub = 'pub',
  Refreshments = 'refreshments',
  RegionalProducts = 'regionalProducts',
  RussianCuisine = 'russianCuisine',
  SaladBar = 'saladBar',
  Sandwich = 'sandwich',
  Schnitzel = 'schnitzel',
  SeaView = 'seaView',
  Seafood = 'seafood',
  Shashlik = 'shashlik',
  Shisha = 'shisha',
  Smoothies = 'smoothies',
  SouthAmericanCuisine = 'southAmericanCuisine',
  SpanishCuisine = 'spanishCuisine',
  SportsBar = 'sportsBar',
  SteakHouse = 'steakHouse',
  Steakhouse = 'steakhouse',
  Sushi = 'sushi',
  Tapas = 'tapas',
  Tea = 'tea',
  TeaShop = 'teaShop',
  ThaiCuisine = 'thaiCuisine',
  Tobacco = 'tobacco',
  TraditionalCuisine = 'traditionalCuisine',
  TurkishCuisine = 'turkishCuisine',
  UkrainianCuisine = 'ukrainianCuisine',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  VietnameseCuisine = 'vietnameseCuisine',
  Wine = 'wine',
}

export interface IOfferingRelation {
  offering: IOffering;
  categories: ICategory[];
}

export interface IOfferingGroup {
  group: IGroup;
  icon: string;
  offerings: IOfferingRelation[];
}

export const offeringGroups: Record<string, IOfferingGroup> = {};
